import { render, staticRenderFns } from "./SearchDxComponent.vue?vue&type=template&id=748f0a8d&scoped=true"
import script from "./SearchDxComponent.vue?vue&type=script&lang=js"
export * from "./SearchDxComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "748f0a8d",
  null
  
)

export default component.exports